import { ExperimentGroup, UserExperiments } from "@/helpers/const";
import { createCommonApiResponseSchema } from "@/server/agentTypes";
import { z } from "zod";

type Contra<T> = T extends any ? (arg: T) => void : never;
type InferContra<T> = [T] extends [(arg: infer I) => void] ? I : never;
type PickOne<T> = InferContra<InferContra<Contra<Contra<T>>>>;
type Union2Tuple<T> =
  PickOne<T> extends infer U
    ? Exclude<T, U> extends never
      ? [T]
      : [...Union2Tuple<Exclude<T, U>>, U]
    : never;

type ExperimentGroup = (typeof ExperimentGroup)[keyof typeof ExperimentGroup];
type ExperimentGroupTuple = Union2Tuple<ExperimentGroup>;

export const GetGroupsResponseSchema = createCommonApiResponseSchema(
  z.object({
    data: z.object(
      Object.fromEntries(
        Object.entries(UserExperiments).map(([key, value]) => [
          value,
          z
            .enum(Object.values(ExperimentGroup) as ExperimentGroupTuple)
            .optional(),
        ])
      )
    ),
  })
);

type GetGroupsResponse = z.infer<typeof GetGroupsResponseSchema>;
